
import { Toaster as Sonner, ToasterProps } from "sonner";
import { useBryntumTheme } from "@/contexts/BryntumThemeContext";

const Toaster = ({ ...props }: ToasterProps) => {
  const { isDarkTheme } = useBryntumTheme();
  const theme = isDarkTheme ? "dark" : "light";

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
